module.exports = __webpack_public_path__ + "img/k-black-woman-back.6aeacc6b.jpg";